import { paymentTypes } from 'constants/campaignConstants';

const commonConfig = {
  defaultPath: '/campaigns',
  fontFamily: '\'Roboto\', sans-serif',
  borderRadius: 12,
  outlinedFilled: true,
  theme: 'light',
  presetColor: 'default',
  i18n: 'en',
  defaultCampaignDuration: null,
  defaultCampaignPaymentType: paymentTypes.MONTHLY_SUBSCRIPTION,
  annualDiscountPercent: 25,
  maxImageSize: '10485760',
  // Google Maps API Key can be overridden by environment variable
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyBTomgHgMgBXgAcMqpaDJdouwNQaXD1f8Y',
};

const prodConfig = {
  basename: '/prod',
  graphqlUrl: 'https://be-terraboost-v3.terraboost.com/graphql',
  apiBaseUrl: 'https://myygj8wp5b.execute-api.us-east-1.amazonaws.com/prod/',
  portalAppLink: process.env.REACT_APP_PORTAL_APP_LINK || 'https://portal.terraboost.com',
  cognito: {
    REGION: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_hrkCEFmmM',
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '4cebnbhf0ldrc0j9a9tmueserm'
  }
};

const QAConfig = {
  basename: '/qa',
  graphqlUrl: 'https://be-qa-environment.focusteck.com/graphql',
  apiBaseUrl: 'https://myygj8wp5b.execute-api.us-east-1.amazonaws.com/qa/',
  portalAppLink: process.env.REACT_APP_PORTAL_APP_LINK || 'https://victorious-plant-06bb77510.3.azurestaticapps.net',
  cognito: {
    REGION: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_k23bLOS2R',
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '7s2fg6mvnshp45s3sffpa13g0e'
  }
};

const stageConfig = {
  basename: '/stage',
  graphqlUrl: 'https://be-terraboost-v3-stage.focusteck.com/graphql',
  apiBaseUrl: 'https://myygj8wp5b.execute-api.us-east-1.amazonaws.com/stage/',
  portalAppLink: process.env.REACT_APP_PORTAL_APP_LINK || 'https://staging.portal.terraboost.com',
  cognito: {
    REGION: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_2VN6zOZVe',
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '3e1sp66cgskv4jabes565nmppg'
  }
};

const devConfig = {
  basename: '/dev',
  graphqlUrl: 'http://localhost:5001/graphql',
  apiBaseUrl: 'https://myygj8wp5b.execute-api.us-east-1.amazonaws.com/stage/',
  portalAppLink: process.env.REACT_APP_PORTAL_APP_LINK ||'http://localhost:3000',
  cognito: {
    REGION: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_Glym5JoQb',
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || '258qk6urom3h3f6a32cmprm17d'
  }
};

let config;

switch (process.env.REACT_APP_ENV) {
  case 'prod':
    config = prodConfig;
    break;
  case 'stage':
    config = stageConfig;
    break;
  case 'qa':
    config = QAConfig;
    break;
  default:
    config = devConfig;
    break;
}

export default { ...commonConfig, ...config };
